export enum AuthRoutePath {
    Login = '/login'
}
